import React from 'react'
import styles from './Hamburger.module.css';

const Hamburger=(props)=>{
    return (
     	<div className={[props.open===true?styles.open:undefined,styles.mobile_hamburger].join(' ')} onClick={props.onClick}>
			<span/>
			<span/>
			<span/>
		</div>
    )
}

export default Hamburger;